import * as numeral from 'numeral';
import { differenceInMonths } from 'date-fns';
import { Addon } from '../components/Inputs/TextInput/TextInput';
import { Frequency, calcConfig } from '../content/content';

interface YearsAndMonths {
  years: number;
  months: number;
}

export const formatDate = (d: string) => `${d.split('/')[2]}/${d.split('/')[1]}/${d.split('/')[0]}`;

export const formatFrequency = (frequency: Frequency) => (frequency === Frequency.Monthly ? 'M' : 'A');

export const getCurrentAge = (dateOfBirth: string) => differenceInMonths(new Date(), dateOfBirth);

export const getPlanMinusLumpSumValue = (planValue: number, lumpsum: number, lumpsumType = Addon.Pound) => {
  if (lumpsumType === Addon.Percentage) {
    return Number((planValue - (planValue * (lumpsum / 100))).toFixed(2));
  }
  return planValue - lumpsum;
};

export const splitYearsAndMonths = (monthsTotal: number) => ({
  years: Math.abs(Math.trunc(monthsTotal / 12)),
  months: Math.abs(monthsTotal - (Math.trunc(monthsTotal / 12) * 12)),
});

export const getAnnualValue = (value: string, frequency: Frequency) => (frequency === Frequency.Monthly ? numeral(value).multiply(12).value() : Number(value));

export const getPercentage = (amount: number, total: string) => numeral(amount).divide(total).format('0.0%');

export const getExpectedDeathAge = (longLifeResults: number[], currentAge: number) => longLifeResults
  .map((probability: number, index: number) => ({ probability, age: index + currentAge + 1 }))
  .filter((item: any) => item.probability < calcConfig.lifeExpectancyProbabilityPercentage)[0].age;

export const pluralise = (count: number, term: string) => `${count} ${term}${count !== 1 ? 's' : ''}`;

export const printDate = (date: YearsAndMonths) => `${pluralise(date.years, 'year')} and ${pluralise(date.months, 'month')}`;

export const printDateComma = (date: YearsAndMonths) => `${pluralise(date.years, 'year')}, ${pluralise(date.months, 'month')}`;

export const getDrawdown = (amount: string, frequency: Frequency) => (frequency === Frequency.Yearly ? Number(amount) : numeral(amount).multiply(12).value());



// WEBPACK FOOTER //
// ./src/utilities/calculatorHelpers.ts